import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="mt-5">
      <div className="icons d-flex justify-content-center">
        <p>
          Built with<span className="me-2"></span>
          <i id="React">
            <img src="/logo192.png" alt="React" className="me-1" />
          </i>
          <i id="Bootstrap">
            <img src="./img/Bootstrap_logo.png" alt="Bootstrap" />
          </i>
          <i id="AWS">
            <img src="./img/aws-logo.png" alt="AWS" />
          </i>
        </p>
      </div>
      <p id="copyright-message">
        Created by Dragon2462 (my web handle) | © 2026 Poul Zheng. All rights reserved.
      </p>
      {/* <a className="btn btn-sm btn-light" href="/" id="scrollUp">
        Back to Top
      </a> */}
    </footer>
  );
}

export default Footer;
